export default "__VITE_ASSET__BNP2D_tg__"